<template>
    <router-view :pmsConnDetails="pmsConnDetails" :pmsInfoLoading="loading" :pmsInfo="pmsInfo"></router-view>
</template>
<script>
import { API, Auth, graphqlOperation } from "aws-amplify";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      loading: false,
      requestingPmsInfoUpdate: false,
      pmsInfoUpdateRequested: false,
      pmsInfo: {},
      sub: "",
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;
    await this.getPMSInfo(this.sub);
  },
  methods: {
    async getPMSInfo(sub) {
      this.loading = true;
      try {
        // Simple query
        //const allStatus = await API.graphql(graphqlOperation(queries.listStatus));
        console.log({ msg: "getPMSInfo", sub });
        const pmsInfo = await API.graphql(
          graphqlOperation(queries.getPmsInfo, { sub: sub })
        );

        console.log("pmsInfo", pmsInfo);

        if ((pmsInfo?.data?.getPMSInfo?.usr ?? "") === "") {
          this.msg = "Can't retrieve PMS Info details";
          return;
        }

        let jsonObj = JSON.parse(
          JSON.parse(pmsInfo.data.getPMSInfo?.details)
        );

        try {
            if (jsonObj.s3Link) {
                // Get s3 data
                const bucket = "pmsinfo"
                const key = jsonObj.s3Link
                let jsonData;
                let error;

                const credentials = await Auth.currentCredentials();
                const s3 = new S3Client({
                  region: 'ap-southeast-2',
                  credentials,
                });
                const params = {
                    Bucket: bucket,
                    Key: key,
                };

                // Merge with the parent data
                const command = new GetObjectCommand(params);
                const response = await s3.send(command);
                const body = await new Response(response.Body).text();
                const parsedJson = JSON.parse(body);

                jsonObj = { ...jsonObj, ...parsedJson };
            }
        } catch (error) {
            console.error('Error getting and/or parsing object:', error);
        }

        //this.msg = status.data.getPMSInfo.usr;
        this.pmsInfo = jsonObj;

        console.log("parse pmsinfo", this.pmsInfo);
      } catch (err) {
        this.msg = err;
        this.items = {};
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async requestPmsInfoUpdate() {
      this.requestingPmsInfoUpdate = true;
      const taskRequest = await API.graphql(
        graphqlOperation(mutations.publishTaskRequest, {
          sub: this.sub,
          command: "TaskRequest",
          taskType: "GetPMSInfo",
        })
      );

      // smoke & mirrors ftw
      setTimeout(() => {
        this.requestingPmsInfoUpdate = false;
        this.pmsInfoUpdateRequested = true;
      }, 1500);
    },
  },
};
</script>